import { normalQueryTypes } from '@ow/utils'

const filterSpec = {
  queryTypes: ['equal'].map((p) => normalQueryTypes[p]),
}

export { filterSpec }

export const config = {
  slug: '',
  title: '点位',
  type: 'area',
  intro: '点位设置',
  required: false,
  description: '字段描述',
  readonly: false,
  hidden: false,
  defaultValue: [],
}
